'use es6';

import PropType from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GenericSplashMessage = ({
  title = null,
  description = null
}) => /*#__PURE__*/_jsxs(Text, {
  padding: "1000",
  textAlign: "center",
  marginBlock: "600",
  as: "div",
  children: [/*#__PURE__*/_jsx("h4", {
    children: title
  }), description]
});
GenericSplashMessage.propTypes = {
  title: PropType.node,
  description: PropType.node,
  className: PropType.string
};
export default GenericSplashMessage;